<template>
  <v-container>
    <ViewsContainer
      :moduleName="moduleName"
      :listViewComponent="Table"
      :calendarViewComponent="Calendar"
      :filterComponent="Filter"
      :data="data"
      :config="'@/components/modules/activities/activities.config'"
      :onCreate="create"
      :onUpdate="update"
      :onDelete="remove"
      :show_toolbar="true"
      :show_pagination="currentView!='calendar'"
      :title="{singular:'Actividad', plural:'Actividades'}"
    />
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useActivitiesStore } from '@/store/activities';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/activities/activities.config';
import { useRoute } from 'vue-router';

import Table from '@/components/views/TableView.vue';
import Calendar from '@/components/views/calendar/Container.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'

import { useLayoutField } from '@/composables/useLayoutField';

const route = useRoute();
const moduleName = (route.meta.moduleName ?? route.name) as string;
const preferencesStore = usePreferencesStore();
const activitiesStore = useActivitiesStore();

const currentView = useLayoutField(moduleName, 'currentView');

const {
  create,
  update,
  remove,
} = useModuleLayoutFetcher(
  moduleName,
  (params) => activitiesStore.fetchActivities(params),
  {
    create: activitiesStore.createActivity,
    update: (data) => activitiesStore.updateActivity(data.id, data),
    remove: activitiesStore.deleteActivity,
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  preferencesStore.setAllModuleHeaders(HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => activitiesStore.activities);

</script>
